import React from 'react';
import { Container } from 'react-bootstrap';

const About = () => {
  return (
    <section id="about">
      <Container>
        <h2 className="text-center mb-4">Witamy w naszym hotelu w Czyżewie!</h2>
        <p>
          Nasz obiekt znajduje się w samym sercu Czyżewa, w dogodnej odległości od Ciechanowca, Wysokiego Mazowieckiego i Zambrowa. Oferujemy komfortowy wypoczynek w przyjemnej atmosferze, idealny zarówno dla turystów, jak i podróżujących w celach biznesowych.
        </p>
        <p>
          Do Państwa dyspozycji oddajemy 24 miejsca noclegowe w przestronnych pokojach 2-, 3- i 4-osobowych, z każdym wyposażonym w nowoczesną łazienkę z prysznicem, wygodne łóżka, przestronną szafę, stół z krzesłami oraz telewizor.
        </p>
        <p>
          Nasi goście mogą korzystać z w pełni wyposażonej kuchni, gdzie znajdą wysokiej jakości sprzęt AGD oraz duży stół jadalniany. Na terenie obiektu dostępny jest parking oraz darmowe Wi-Fi, co zapewnia komfort i wygodę podczas pobytu.
        </p>
        <p>
          Ceny noclegów uzależnione są od długości pobytu, a dla firm istnieje możliwość wystawienia faktury VAT. Zapraszamy do rezerwacji i spędzenia niezapomnianych chwil w naszym hotelu!
        </p>
      </Container>
    </section>
  );
};

export default About;
